<template>
    <section class="my-md-4">
        <div class="filter_block">
            <div class="drop_block" tabindex="0" @focusout="openDropDown = false">
                <div class="current_active" @click="openDropDown = !openDropDown">
                    <div class="d-flex align-items-center me-2 select_text">
                        <span>Sort by : {{ newsort }}</span> 
                    </div>
                    <div class="arr_box">
                        <SvgHeaderSvg v-if="!openDropDown" :type="'down'" />
                        <SvgHeaderSvg v-else :type="'up'" />
                    </div>
                </div>
                <ul v-if="openDropDown" class="drop_item p-0"> 
                    <li v-for="option in sortOptions" 
                        :key="option.value"
                        @click="toggleSort(option.value)" 
                        :class="{ 'active': newsort === option.value }"> 
                        <span>{{ option.label }}</span>
                    </li>
                </ul>
            </div>
            <div class="overflow">
                <div class="over_box">
                    <NuxtLink class="filter_box" :to="localePath('/blog')"><img src="~/assets/blog/svg/all_blogs.svg" width="30" height="30" alt="" /><span>All Blogs</span></NuxtLink>
                    <NuxtLink class="filter_box" :to="localePath('/blog/category/new-trends')"><img src="~/assets/blog/svg/new_trend.svg" width="30" height="30" alt="" /><span> New Trends</span></NuxtLink>
                    <NuxtLink class="filter_box" :to="localePath('/blog/category/gift-ideas')"><img src="~/assets/blog/svg/gift_guide.svg" width="30" height="30" alt="" /><span> Gift Ideas</span></NuxtLink>
                    <NuxtLink class="filter_box" :to="localePath('/blog/category/diamond-guide')"><img src="~/assets/blog/svg/know_diam.svg" width="30" height="30" alt="" /><span> Diamond Guide</span></NuxtLink>
                    <NuxtLink class="filter_box" :to="localePath('/blog/category/all-about-rings')"><img src="~/assets/blog/svg/ring_wedding.svg" width="30" height="30" alt="" /><span>All About Rings</span></NuxtLink>
                    <NuxtLink class="filter_box" :to="localePath('/blog/category/jewelry-guide')"><img src="~/assets/blog/svg/jewelry_guide.svg" width="30" height="30" alt="" /><span>{{ $t('jewelry') }} Guide</span></NuxtLink>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

    const localePath = useLocalePath()
    const props = defineProps(['filters'])
    const emit = defineEmits(['toggleSort'])

    const openDropDown = ref(false)

    const newsort = ref(props.filters.sort)

    const sortOptions = ref([
        { value: 'newest', label: 'Newest' },
        { value: 'oldest', label: 'Oldest' },
        { value: 'popular', label: 'Popular' }
    ])
    watch(() => props.filters.sort, (newSort) => {
        newsort.value = newSort;
    });
    const toggleSort = (value) => {
        newsort.value = value
        openDropDown.value = false 
        emit('toggleSort', newsort.value) 
    }
</script>

<style scoped>
   
    span {
        font-size: 16px;
    }
    .custom-select {
        border: 0;
    }

    .custom-select:focus {
        box-shadow: none;
    }

    .filter_box.filter_box_sort select {
        width: 100px;
        outline: none;
    }
    .filter_block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 4% 0;
    }
    .filter_box {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #000;
    }
    .filter_box span {
        margin-left: 9px;
        text-transform: capitalize;
    }
  
    .filter_box.nuxt-link-exact-active span {
        color: #000;
    }
    a.router-link-active.router-link-exact-active.filter_box span{
        color: var(--green);
    }

    /* Sort Drop */
    .label_box a .svg-head {
    margin: 0 0 -2px 9px;
    }
    p{
        font-size: 12px;
        font-weight: 600;
    }
    p a{
        color: var(--green);
    }
    .arr_box svg.svg-head {
        height: 16px;
    }
    .drop_block.invalid .current_active {
        border: 1px solid rgb(255, 2, 2);
    }
    .label_box {
        font-size: 14px;
        font-weight: 600;
        text-transform: capitalize;
        color: #212529;
    }
    .label_box div{
        color: rgb(159, 158, 158);
        cursor: pointer;
    }
    .drop_block{
        position: relative;
    }
    .current_active {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 1.5;
        color: #000;
        vertical-align: middle;
        padding: 0 10px;
        font-size: 14px;
        cursor: pointer;
        height: 44px;
        border-radius: 8px;
    }

    label {
        font-size: 16px;
        color: #303030;
        line-height: 1.3;
    }
    .current_active.focused {
        border-color: var(--green);
        box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
    }
    ul {
        border: 1px solid #c4c4c4;
        position: absolute;
        top: 100%;
        left: 40%;
        width: 100%;
        background: #fff;
        z-index: 9;
        padding: 10px 0;
        max-height: 220px;
        overflow: auto;
        border-radius: 8px;
    }
    ul li{
        list-style: none;
        padding: 5px 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        text-transform: capitalize;
    }
    ul li.active {
        border-color: var(--green);
    }
    span{
        font-weight: 400;
        font-size: 14px;
        color: #212529;
        text-transform: capitalize;
    }

    ul li.disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    /* Sort Drop */

    .over_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .over_box a {
        margin-left: 30px;
    }
   
    @media(max-width: 1300px){
        .overflow {
            overflow-x: scroll;
            overflow-y: hidden;
        }

        .over_box {
            width: 1000px !important;
        }

        .filter_box.filter_box_sort {
            width: 33%;
        }
    }
    @media(max-width: 992px){
        .over_box .filter_box {
            width: auto;
        }
        .over_box a {
            margin-left: 15px;
        }
        .filter_block {
            flex-wrap: wrap;
        }
        .filter_box {
            width: 33%;
        }
    }
    @media(max-width: 767px){
        .over_box a {
            margin-left: 0;
            margin-right: 10px;
        }
        .over_box{
            justify-content: flex-start;
            width: 780px !important;
            margin-bottom: 10px;
        }
        span {
            font-size: 14px;
            margin-left: 0 !important;
        }
        .filter_box.filter_box_sort {
            width: 100%;
        }

        .filter_box {
            width: 50%;
            padding: 1% 0;
        }
        .filter_box_sort span {
            margin-left: 0;
        }
         .over_box a img{
            display: none;
         }
        .over_box .filter_box{
            background: #eaeaea;
            justify-content: center;
            border-radius: 20px;
            padding: 7px 15px;
        }
       a.router-link-active.router-link-exact-active.filter_box {
            background: var(--green);
        }
        a.router-link-active.router-link-exact-active.filter_box span{
            color: #fff;
        }
        .filter_block {
            margin: 8% 0 2%;
        }
        .mobile_sort {
            display: flex;
            align-items: center;
            margin-bottom: 8%;
            justify-content: flex-end;
        }

        .mobile_sort select {
            width: 120px;
            outline: none;
            box-shadow: none;
        }
        /* Blog Sort Drop */
        label {
            font-size: 14px;
            /* margin-bottom: 5px !important; */
            }
        .label_box {
                font-size: 14px;
                font-weight: 600;
                /* margin-bottom: 0 !important; */
            }
        .drop_block{
                margin-bottom: 8px;
            }
    }

</style>